/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';
import icon from '../../../../resources/checkmark@1x.png';
import { useStyles } from './styles';

const { Option } = components;

const OptionComponent = ({ data, isSelected, ...otherProps }) => {
  const classes = useStyles();
  return (
    <Option {...otherProps}>
      {data.label}
      {isSelected && (
        <div className={classes.optionIcon}>
          <img
            src={icon}
            className={classes.optionIcon}
            alt="selected"
          />
        </div>
      )}
    </Option>
  );
};


OptionComponent.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default OptionComponent;
